import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DCSummaryBlock slots="heading, text, buttons" background="rgb(31, 42, 73)" btnVariant="cta" buttonPositionRight className="Reinvent py-2 reimagine" mdxType="DCSummaryBlock" />
    <h2 {...{
      "id": "reimagine-your-document-experiences-today"
    }}>{`Reimagine your document experiences today.`}</h2>
    <p>{`Activate your free tier of 1,000 document transactions to start leveraging SDKs for Node.js, .Net, Java, Python, and sample Postman collections.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html"
        }}>{`Start for free`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/pricing/contact/"
        }}>{`Talk to an expert`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      